/* eslint-disable eqeqeq */
export const everyPairNonEmpty = (obj: any, hasErrors: boolean) => {
	const values = Object.keys(obj).map(v => {
		if (obj[v] === undefined) {
			return ' ';
		} else if (v === 'stateId') {
			return obj.state;
		} else {
			return obj[v];
		}
	});
	const booleanMatching = hasErrors ? [false] : values.map(v => v.toString().length > 0 || Array.isArray(v));
	return booleanMatching.every(v => v === true);
};
